export default __webpack_public_path__ + "static/media/CarGo_Homepage_Flash_v2_MobileFlash.addbfc92.png";